var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('LiLoading',{directives:[{name:"show",rawName:"v-show",value:(_vm.isLoading),expression:"isLoading"}],staticClass:"LiLoading"}),_c('iframe',{staticClass:"iframe",attrs:{"src":"https://blog.litely.life","frameBorder":"0"},on:{"load":_vm.onLoad}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }